(() => {
  const DRAWER_SELECTORS = [
    'cart-drawer',
    '#CartDrawer',
    '#cart-drawer',
    '.cart-drawer',
    '[data-cart-drawer]'
  ];

  const COUNT_SELECTORS = [
    '.cart-count-bubble',
    '#cart-icon-bubble',
    '[data-cart-count]'
  ];

  function getDrawer() {
    for (const s of DRAWER_SELECTORS) {
      const el = document.querySelector(s);
      if (el) return el;
    }
    return null;
  }

  function openDrawer() {
    const drawer = getDrawer();
    if (!drawer) return false;

    if (typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }

    drawer.setAttribute?.('open', '');
    drawer.classList?.add('open', 'is-open', 'active');
    document.body.classList.add('overflow-hidden');
    return true;
  }

  function isListingPage() {
    const c = document.body.className || '';
    return (
      c.includes('template-collection') ||
      c.includes('template-index') ||
      c.includes('template-search')
    );
  }

  function getCountEl() {
    for (const s of COUNT_SELECTORS) {
      const el = document.querySelector(s);
      if (el) return el;
    }
    return null;
  }

  function readCount() {
    const el = getCountEl();
    if (!el) return null;

    // Busca un número en el texto (ej: "3")
    const txt = (el.textContent || '').trim();
    const m = txt.match(/\d+/);
    return m ? parseInt(m[0], 10) : 0;
  }

  // Observa cambios del contador y abre drawer si sube (solo en listados)
  function observeCountIncrease() {
    const el = getCountEl();
    if (!el) return false;

    let last = readCount();

    const obs = new MutationObserver(() => {
      if (!isListingPage()) return;
      const now = readCount();
      if (now == null) return;

      // Si subió el contador, abrimos drawer
      if (typeof last === 'number' && now > last) {
        setTimeout(() => openDrawer(), 50);
      }
      last = now;
    });

    obs.observe(el, { childList: true, subtree: true, characterData: true });
    return true;
  }

  // Fallback: si no hay contador visible, detecta aumento con /cart.js tras clicks
  async function getCartCountFromAPI() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) return null;
    const data = await res.json();
    return typeof data.item_count === 'number' ? data.item_count : null;
  }

  function clickFallbackIfNoBubble() {
    let lastCount = null;

    // inicializa
    getCartCountFromAPI().then(c => (lastCount = c)).catch(() => {});

    document.addEventListener(
      'click',
      async (e) => {
        if (!isListingPage()) return;

        const btn = e.target.closest('button, a, input[type="submit"]');
        if (!btn) return;

        // Heurística: botones típicos de quick add / + piezas suelen ser button
        // (No filtramos demasiado para no “perder” el evento)
        setTimeout(async () => {
          const now = await getCartCountFromAPI();
          if (now == null) return;

          if (typeof lastCount === 'number' && now > lastCount) {
            openDrawer();
          }
          lastCount = now;
        }, 300);
      },
      true
    );
  }

  // Arranque
  const ok = observeCountIncrease();
  if (!ok) {
    // Si no encontramos burbuja/contador, usa fallback por API
    clickFallbackIfNoBubble();
  }
})();
